import { render, staticRenderFns } from "./IcoArrowSwapSquare.vue?vue&type=template&id=72c82a60"
import script from "./IcoArrowSwapSquare.vue?vue&type=script&lang=js"
export * from "./IcoArrowSwapSquare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports